import CommonIcon from 'CommonIcon'
import type { ReactNode } from 'react'
import React from 'react'

import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  flagWrapper: {
    marginRight: '0.2rem',
    minWidth: '1.3rem',
    width: '1.3rem',
  },
})

interface Props {
  childProps: any
  children?: ReactNode
}

function NameColumn({ children, childProps }: Props) {
  const classes = useStyles()
  const { displayChannel, store, type } = childProps
  const showStoreChannel = type === 'group' || displayChannel

  return (
    <>
      <div className={classes.flagWrapper}>
        <CommonIcon name={store.storeChannel} />
        {children}
      </div>
      {store.position}
      {showStoreChannel && store.storeChannel} {store.storeName}
    </>
  )
}

export default NameColumn
